import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faTimes, faSearch } from '@fortawesome/free-solid-svg-icons';
import Button from '../../../../form/Button';
import Input from '../../../../form/Input';

interface ContactsToolbarProps {
    searchValue: string;
    onSearchChange: (value: string) => void;
    onNewContact: () => void;
    isActionDisabled?: boolean;
}

export function ContactsToolbar({
    searchValue,
    onSearchChange,
    onNewContact,
    isActionDisabled = false,
}: ContactsToolbarProps) {
    return (
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="relative w-full sm:w-72 md:w-96">
                <div className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                    <FontAwesomeIcon icon={faSearch} size="sm" />
                </div>

                <Input
                    name="contacts-search-bar"
                    className="w-full px-10"
                    aria-label={gettext('CONTACTS_SEARCH_PLACEHOLDER')}
                    placeholder={gettext('CONTACTS_SEARCH_PLACEHOLDER')}
                    value={searchValue}
                    onChange={(e) => onSearchChange(e.target.value)}
                />

                {searchValue && (
                    <button
                        type="button"
                        onClick={() => onSearchChange('')}
                        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-gray-400 transition-colors hover:text-gray-600"
                        aria-label={gettext('CLEAR_SEARCH')}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                )}
            </div>
            <div className="flex items-center gap-4">
                <Button
                    variant="primary"
                    onClick={onNewContact}
                    disabled={isActionDisabled}
                    className="w-full sm:w-auto"
                >
                    <FontAwesomeIcon icon={faUserPlus} className="mr-2" />
                    {gettext('NEW_CONTACT')}
                </Button>
            </div>
        </div>
    );
}
